import { WithAccountProps } from 'hoc/withAccount'
import withAccountStatus from 'hoc/withAccountStatus'
import { memo } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Box } from '@chakra-ui/react'
import { useLocation } from 'react-router-dom'
import Appointments from './Appointments'
import ComingUp from './ComingUp'
import Completed from './Completed'
import './styles.scss'
import Timeline from './Timeline'
import AppointmentButton from './AppointmentButton'
import { useBreakpointContext } from 'context/Breakpoint'
import { BookingEventSource } from 'utils/amplitude.types'
import { RoutePaths } from 'containers/Core/Routes'

const Dashboard: React.FC<WithAccountProps> = (props) => {
  const location = useLocation()
  const { isMobile } = useBreakpointContext()

  const getQueryParams = (query: string) => {
    return new URLSearchParams(query)
  }

  const queryParams = getQueryParams(location.search)
  const from = queryParams.get('from')
  const shouldRefetch = from === 'scheduling' || from === 'labScheduling'

  return (
    <Container fluid className={`px-0 mt-lg-2 dashboard`}>
      <Row className="h-100 ">
        <Timeline {...props} />

        <Col sm={12} xl={6} className="dashboard-col-l">
          <ComingUp {...props} />
          <Completed {...props} />
        </Col>
        <Col sm={12} xl={6}>
          <Appointments performRefetch={shouldRefetch} user={props.user} />
        </Col>
      </Row>
      <Box
        p={4}
        position={'fixed'}
        display={isMobile ? 'block' : 'none'}
        zIndex={1000}
        bottom={0}
        left={'50%'}
        transform={'translateX(-50%)'}
        width={'100vw'}
        bg={'white'}
      >
        <AppointmentButton
          appointmentLink={`${RoutePaths.SCHEDULING}?source=${BookingEventSource.STICKY_CTA_BUTTON}`}
          applyPrimaryStyle={false}
        >
          Book My Visit
        </AppointmentButton>
      </Box>
    </Container>
  )
}

export default withAccountStatus(memo(Dashboard))
